import Component from '../core/Component';
import $ from 'jquery';
import enquire from 'enquire.js';
import { queries } from '../core/config';
//import loadTouchEvents from 'jquery-touch-events';
//loadTouchEvents($);

export default class Tabs extends Component
{
    constructor($element)
    {
        super($element);
        this.tabsItems = $element.find('[data-tabs-item]');
        this.tabsControlItems = $element.find('[data-tabs-control-item]');

        this.max = this.tabsItems.length;
    }

    prepare()
    {
        enquire.register(queries.mediumUp, {
            match: () => {
                var maxHeight = 0;
                this.tabsItems.each(function () {
                    if ($(this).height() >= maxHeight) {
                        maxHeight = $(this).outerHeight();
                    }
                });
                this.tabsItems.parent().css('height', maxHeight + 'px');
            }
        });

        var self = this;
        //this.tabsItems.eq(0).addClass('active');
        //this.tabsControlItems.eq(0).addClass('active');

        this.tabsControlItems.on('click', function (event) {
            event.preventDefault();
            var target = $(this).attr('href');
            self.makeActive(target, $(this));
        });

        //enquire.register(queries.mediumMax, {
        //    match: () => {
        //        this.$element.on('swipeleft', event => {
        //            self.next();
        //            self.createLoop();
        //        });
        //        this.$element.on('swiperight', event => {
        //            self.prev();
        //            self.createLoop();
        //        });
        //    }
        //});
    }

    eraseActiveClasses () {
        this.tabsItems.removeClass('active');
        this.tabsControlItems.removeClass('active');
    }

    makeActive (target, control) {
        this.eraseActiveClasses();
        control.addClass('active');
        target = target.replace('#', '');

        this.tabsItems.each(function () {
            if ($(this).attr('id') == target)
                $(this).addClass('active');
        });
    }

}


// WEBPACK FOOTER //
// ./components/Tabs.js